import { useEffect, useRef } from "react"
import FileDownload from "../SystemSetup/ImportExport/FileDownload"
import dayjs from 'dayjs'

type Props = {
  handleExport: boolean | null
  summaryReportUrl: string
  timesheetReportUrl: string
  startingDate: string
  endingDate?: string
}

const TimeCsvExporter = ({handleExport, summaryReportUrl, timesheetReportUrl, startingDate, endingDate}: Props) => {
  const fileDownloadRef = useRef<any>()
  const startDate = dayjs(startingDate).format('YYYYMMDD')
  const endDate = endingDate ? dayjs(endingDate).format('YYYYMMDD') : dayjs().add(1,'day').format('YYYYMMDD')

  const exportTimesheetReport = async () => {
    await fileDownloadRef.current.download(timesheetReportUrl, 'TimesheetReport.csv', true)
    }

    const exportSummaryReport = async () => {
      await fileDownloadRef.current.download(summaryReportUrl, 'TimesheetSummaryReport-'+startDate+'-'+endDate+'.csv', true)
      }

  useEffect(() => {
    if(handleExport !== null)
    {
      exportTimesheetReport()
      exportSummaryReport()
    }
  }, [handleExport])
  
  return <FileDownload ref={fileDownloadRef} />
}

export default TimeCsvExporter